import { render, staticRenderFns } from "./GetInTouch.vue?vue&type=template&id=700c7582&"
import script from "./GetInTouch.vue?vue&type=script&lang=js&"
export * from "./GetInTouch.vue?vue&type=script&lang=js&"
import style0 from "./GetInTouch.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QDialog,QCard,QStepper,QStep,QCardSection,QSeparator,QCardActions,QBtn,QInput,QSelect,QInnerLoading,QSpinner,QField} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QDialog,QCard,QStepper,QStep,QCardSection,QSeparator,QCardActions,QBtn,QInput,QSelect,QInnerLoading,QSpinner,QField})
